import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { ItemIcon } from "@similarweb/ui-components";

export const StyledCompanyLogo = styled(ItemIcon)<{ disabled: boolean }>`
    flex: none;
    z-index: 1;
    ${({ disabled }) =>
        disabled &&
        css`
            background-color: ${colorsPalettes.bluegrey[200]};
            box-shadow: none;
        `}
`;
